import React, {
  useEffect, useState, useRef, useCallback,
} from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Empty } from 'antd';
import WaveSurfer from 'wavesurfer.js';
import { navigate } from '@reach/router';
import Card from '../../../system/card/Card';
import { Container, EmptyArea, StyledButton } from './Styled';
import AudioPlayer from '../audioPlayer/AudioPlayer';
import Chat from './chat/Chat';
import {
  DialogTranscription,
  Speech,
} from '../../../../model/transcription/types';
import { fillTranscriptionSpeech } from '../../../../business/actions/dialogTranscriptionActions';
import { env } from '../../../../helpers/env';
import { RootState } from '../../../../model/rootReducer';

type TranscriptionDetailsProps = {
  transcription: DialogTranscription
}

const TranscriptionDetails: React.FunctionComponent<TranscriptionDetailsProps> = ({
  transcription,
}) => {
  const dispatch = useDispatch();
  const botId = useSelector((state: RootState) => state.bot.selectedBot);
  const [isPlaying, setisPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [waveForm, setWaveform] = useState<WaveSurfer | undefined>(undefined);

  const onPlayMessage = (id: string) => {
    if (waveForm !== undefined) {
      waveForm.regions.list[id].play();
    }
  };

  useEffect(() => {
    if (waveForm !== undefined && transcription.speeches !== undefined) {
      // @ts-ignore
      waveForm.regions.clear();
      transcription.speeches
        .filter((x) => x.start !== null && x.end !== null)
        .map((item: Speech) => waveForm.regions.add({
          id: item.date,
          start: item.start - 0.5,
          end: item.end,
          loop: false,
          color: 'hsla(200, 50%, 70%, 0.3)',
          drag: false,
          handleStyle: {
            left: {
              backgroundColor: 'transparent',
            },
            right: {
              backgroundColor: 'transparent',
            },
          },
        }));

      waveForm.load(
        `${env('REACT_APP_API_URL')
        }/Transcriptions/Audio/${
          botId
        }/${
          transcription?.id}`,
      );

      waveForm.on('ready', () => {
        setIsLoading(false);
      });

      waveForm.on('pause', () => {
        setisPlaying(false);
      });

      waveForm.on('play', () => {
        setisPlaying(true);
      });

      waveForm.on('finish', () => {
        setisPlaying(false);
      });

      setisPlaying(false);
    }

    return () => {
      waveForm?.stop();
    };
  }, [waveForm, transcription]);

  const handlePlay = () => {
    setisPlaying(!isPlaying);
    waveForm?.playPause();
  };

  useEffect(() => {
    if (transcription && transcription.speeches === undefined) {
      dispatch(fillTranscriptionSpeech(transcription.id));
    }
  }, [transcription]);

  const NoData = () => (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={<span>Aucune donnée n'est disponible pour cet appel</span>}
    />
  );

  if (transcription !== undefined) {
   return <Container>
        <Card className="audioPlayerCard">
          <AudioPlayer
            url={
              `${env('REACT_APP_API_URL')
              }/Transcriptions/Audio/${
                botId
              }/${
              transcription?.id}`
            }
            className="audioPlayer"
            isLoading={isLoading}
            isPlaying={isPlaying}
            onPlayPause={handlePlay}
            setWave={setWaveform}
          />
      </Card>
      {transcription.speeches !== undefined && transcription.speeches.length > 0 ?
       <Card className="chat">
        <StyledButton
          shape="circle"
          onClick={() => {
            navigate('monitoringGraph', {
              state: { conversationId: transcription.id },
            });
          }}
          icon={<SearchOutlined />}
        />
        <Chat
          speeches={transcription.speeches}
          onPlayMessage={onPlayMessage}
        />
      </Card> : 
      <EmptyArea>
        <NoData />
      </EmptyArea>
      }

      </Container>
  }
  return null;
};

export default TranscriptionDetails;
